module.exports = __webpack_public_path__ + "static/media/ar.4505dc63.png";